module.exports = __webpack_public_path__ + "static/media/bBabyFood.e37ec485.webp";